import styles from "../landing-page-mobile-one.module.css";

interface HeroSectionMobileProps {
  onClickStart: () => void;
}

export const HeroSectionMobile = (_props: HeroSectionMobileProps) => {
  return <div className={styles.heroSection}></div>;
};
